const MOODS = [
  { v: 1, label: "Heavy" },
  { v: 2, label: "Restless" },
  { v: 3, label: "Okay" },
  { v: 4, label: "Calm" },
  { v: 5, label: "Bright" },
];

export const MoodPicker = ({ value, onChange, testId }) => (
  <div className="flex flex-wrap gap-2" data-testid={testId}>
    {MOODS.map((m) => (
      <button key={m.v} type="button" onClick={() => onChange(m.v)} data-testid={`${testId}-${m.v}`}
        className={`px-4 py-2 rounded-full text-sm border transition-colors ${
          value === m.v ? "bg-[#2C4A3E] text-white border-[#2C4A3E]" : "bg-white/60 border-[#E6DEC3] hover:border-[#2C4A3E]"}`}>
        {m.label}
      </button>
    ))}
  </div>
);
